import githubLogo from './github-logo.svg';
import stackOverflowLogo from './stackoverflow-logo.svg';
import gmailLogo from './gmail-logo.svg';
import facebookLogo from './facebook-logo.svg';

export default [
  {
    href: 'https://github.com/sergei-zelinsky',
    name: 'GitHub',
    imageURL: githubLogo,
    color: '#28a745'
  },
  {
    href: 'https://stackoverflow.com/users/6668673/sergei?tab=profile',
    name: 'StackOverflow',
    imageURL: stackOverflowLogo,
    color: '#f48024'
  },
  {
    href: 'https://www.facebook.com/sergei.zelinsky.1',
    name: 'Facebook',
    imageURL: facebookLogo,
    color: '#3c5a97'
  },
  {
    href: 'mailto:sergei.zelinsky.dev@gmail.com',
    name: 'Gmail',
    imageURL: gmailLogo,
    color: '#d22f2b'
  }
];



// WEBPACK FOOTER //
// ./src/constants/social-links/index.js